export function isNumberLike(value?: unknown): value is number | string {
  return !isNaN(parseFloat(value as string)) && isFinite(value as number);
}
